const SelfServePostBuilderSidePanelConstants = {
  DISPLAY_PANEL_TYPE: 'SELF_SERVE_POST_BUILDER_PANEL_TYPE_DISPLAY',
};

export const SelfServePostBuilderSidePanelTypes = {
  SECTION_ORGANIZER: 'SELF_SERVE_POST_BUILDER_SECTION_ORGANIZER',
  RECIPIENT_MANAGER: 'SELF_SERVE_POST_BUILDER_RECIPIENT_MANAGER',
};

export default SelfServePostBuilderSidePanelConstants;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/SelfServePostBuilderSidePanelConstants.jsx